import type { ReactNode } from 'react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { I18nSyncWithBackend } from './i18n-sync-with-backend.component';

type I18nProviderProps = {
  children: ReactNode;
  // Allow apps to specify which languages they support
  supportedLanguages?: string[];
};

export const I18nProvider = ({
  children,
  supportedLanguages = ['en'],
}: I18nProviderProps) => {
  const { i18n } = useTranslation();

  useEffect(() => {
    // Set document language attribute
    document.documentElement.lang = i18n.language;
    document.documentElement.dir = 'ltr';

    // If current language is not supported, fallback to English
    if (!supportedLanguages.includes(i18n.language)) {
      i18n.changeLanguage('en');
    }
  }, [i18n.language, supportedLanguages, i18n]);

  return (
    <>
      {children}

      <I18nSyncWithBackend />
    </>
  );
};
